import { ApiClient } from '../../client';
import {
  TriggerValidationJobRequest,
  TriggerValidationJobResponse,
  ListValidationJobsResponse,
  ValidationJobDetail,
  ActiveJobsSummaryResponse,
  CancelJobResponse,
  RerunJobResponse,
} from './types';

/**
 * Combined validate-products endpoint + job status/control API (issue #637).
 * Every route here is admin-RBAC-gated server-side; the client never needs
 * to duplicate that check beyond deciding whether to render the UI at all.
 */
export class ValidationJobsService {
  constructor(private api: ApiClient) {}

  /** POST /api/validate-products (Endpoint 1) */
  async trigger(payload: TriggerValidationJobRequest) {
    return this.api.post<TriggerValidationJobResponse>(
      '/validate-products',
      payload
    );
  }

  /** GET /api/validation-jobs (Endpoint 2) */
  async list(params?: { limit?: number; offset?: number }) {
    const queryParams = new URLSearchParams();
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());
    const query = queryParams.toString();
    return this.api.get<ListValidationJobsResponse>(
      `/validation-jobs${query ? `?${query}` : ''}`
    );
  }

  /** GET /api/validation-jobs/:jobId (Endpoint 3) */
  async getDetail(jobId: number) {
    return this.api.get<ValidationJobDetail>(`/validation-jobs/${jobId}`);
  }

  /** GET /api/validation-jobs/active-summary (Endpoint 4) */
  async getActiveSummary() {
    return this.api.get<ActiveJobsSummaryResponse>(
      '/validation-jobs/active-summary'
    );
  }

  /** POST /api/validation-jobs/:jobId/cancel (Endpoint 5) */
  async cancel(jobId: number) {
    return this.api.post<CancelJobResponse>(`/validation-jobs/${jobId}/cancel`);
  }

  /** POST /api/validation-jobs/:jobId/rerun (Endpoint 6) */
  async rerun(jobId: number) {
    return this.api.post<RerunJobResponse>(`/validation-jobs/${jobId}/rerun`);
  }
}
